import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../redux/Slice/modalSlice";
import { modalState } from "../utils/constants";
import { useCallback } from "react";

const useClickWithAuth = () => {
  const isAuth = useSelector((state) => state.auth.isAuth);
  const dispatch = useDispatch();

  const handleClick = useCallback(
    (callback) =>
      (...rest) => {
        if (!isAuth) {
          dispatch(openModal(modalState.AUTH));
          return;
        }
        callback(...rest);
      },
    [isAuth, dispatch],
  );

  return handleClick;
};

export default useClickWithAuth;
